import { PrintableDocument } from "@redotech/redo-fulfillment-group-common/print-job";
import { PageSize } from "@redotech/redo-fulfillment-operations-common/packing-slips/packing-slip-builder";
import { PageFormat } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";

export interface PackingSlipAutoPrintTemplate {
  pageLayout: { size: PageSize };
  combineHalfPageSlips?: boolean | null;
}

export interface PackingSlipOnLabelPrintedDecisionInput {
  document: PrintableDocument;
  labelPageFormat: PageFormat;
  packingSlipPageFormat: PageFormat;
  printSlipOnLabelPrinted: boolean | null | undefined;
  packingSlips: readonly PackingSlipAutoPrintTemplate[];
}

function getPackingSlipOnLabelPrintedBaseCondition({
  document,
  labelPageFormat,
  printSlipOnLabelPrinted,
}: PackingSlipOnLabelPrintedDecisionInput) {
  if (document !== PrintableDocument.LABEL) {
    return false;
  }

  if (labelPageFormat !== PageFormat.Label) {
    return false;
  }

  return !!printSlipOnLabelPrinted;
}

export function getShouldPrintPackingSlipOnLabelPrinted(
  input: PackingSlipOnLabelPrintedDecisionInput,
) {
  if (!getPackingSlipOnLabelPrintedBaseCondition(input)) {
    return false;
  }

  if (input.packingSlips.length === 0) {
    return false;
  }

  const everyPackingSlipIsFullSize = input.packingSlips.every(
    (t) => t.pageLayout.size === PageSize.FULL_SIZE,
  );
  const everyPackingSlipIsMergedHalfPage =
    input.packingSlipPageFormat === PageFormat.Letter &&
    input.packingSlips.every(
      (t) =>
        t.pageLayout.size === PageSize.HALF_SIZE && !!t.combineHalfPageSlips,
    );

  return everyPackingSlipIsFullSize || everyPackingSlipIsMergedHalfPage;
}
